<template>
    <div>
        <figure class="tourFigure">
            <div v-if="!showInfo">
                <img :src="getImageSrc(currentTopic.avatar)" class="topicFigureHeight">
                <div class="gradient-box"></div>
                <div class="line-item">
                    <div class="left-item " style="position: fixed; ">
                        <md-button title="Back to Route" class="md-icon-button" @click="returnToPrevious" aria-label="Back">
                            <md-icon>arrow_back</md-icon>
                        </md-button>
                    </div>
                    <div class="left-item" style="position: fixed; margin-left: 3%;">
                        <h3 class="link" @click="toggleInfoBlock('EDITOPEN')">{{ currentTopic.name }}</h3>
                    </div>
                </div>
            </div>
            <div class="info-block" v-if="showInfo">
                <h3>
                    <textarea maxlength="60" rows="1" v-model="currentTopic.name" placeholder="Topic Name"></textarea>
                </h3>
                <p>
                    <textarea maxlength="200" v-model="currentTopic.description"></textarea>
                </p>
                <md-button class="md-icon-button close-info" @click="toggleInfoBlock('EDITCLOSE')">
                    <md-icon>close</md-icon>
                </md-button>
                <md-button class="save-button md-raised md-primary" @click="saveTopicDetails">Save</md-button>
            </div>
        </figure>
    </div>
</template>
<script>
import {saveTopic} from '../../services/EditorService.js';
import {mapGetters} from 'vuex';

export default {
  data: () => ({
    showInfo: false,
    editTourName: '',
    editTourDes: ''
  }),
  computed: {
    ...mapGetters('topics', ['currentTopic'])
  },
  methods: {
    getImageSrc (image) {
      if (image.substring(0, 5) !== 'https') {
        return 'static/img/' + image;
      } else {
        return image;
      }
    },
    toggleInfoBlock (editOpenClose) {
      if (editOpenClose === 'EDITOPEN') {
        this.editTourName = this.currentTopic.name;
        this.editTourDes = this.currentTopic.description;
      }
      if (editOpenClose === 'EDITCLOSE') {
        this.currentTopic.name = this.editTourName;
        this.currentTopic.description = this.editTourDes;
      }
      this.showInfo = !this.showInfo;
    },
    returnToPrevious () {
      this.$router.push('/tour/route');
    },
    async saveTopicDetails () {
      if (this.currentTopic.name.length >= 1) {
        let topic = [this.currentTopic];
        const result = await saveTopic(topic);
        if (result.status !== 200) {
          console.log(result);
        } else {
          this.toggleInfoBlock('SAVECLOSE');
        }
      }
    }
  }
};
</script>
<style lang="scss">
.info-block .save-button {
    bottom: 25px;
}

.tourFigure .topicFigureHeight {
    height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TopicFigure.vue